import { TableRow, TableBody, TableCell, Skeleton } from '@mui/material';

export default function LoadingList({ TABLE_HEAD }) {
  return (
    <TableBody>
      <TableRow>
        <TableCell />
        {TABLE_HEAD.map((data) => (
          <TableCell key={data.id}>
            <Skeleton variant="text" />
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell />
        {TABLE_HEAD.map((data) => (
          <TableCell key={data.id}>
            <Skeleton variant="text" />
          </TableCell>
        ))}
      </TableRow>
      <TableRow>
        <TableCell />
        {TABLE_HEAD.map((data) => (
          <TableCell key={data.id}>
            <Skeleton variant="text" />
          </TableCell>
        ))}
      </TableRow>
    </TableBody>
  );
}
